module.exports = __webpack_public_path__ + "static/media/waveum_white_logo1.fd40e24c.png";